import Vue from "vue";
import VuetifyConfirm from "vuetify-confirm";
import Toasted from "vue-toasted";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import jsplumb from "./plugins/jsPlumber";
import vuetify from "./plugins/vuetify";
import "./plugins/axios";
import "./plugins/vue-storage";
import "./plugins/vue-notification";
import "./plugins/lightRange";

// import the styles

import mixin from "./mixins/index";
import VueSimpleAlert from "vue-simple-alert";
// import the styles

Vue.use(VuetifyConfirm, {
  vuetify,
});
// Vue.config.productionTip = false;
Vue.use(jsplumb);
Vue.use(Toasted, {
  position: "bottom-right",
  duration: 5000,
});
Vue.mixin(mixin);
Vue.use(VueSimpleAlert);

new Vue({
  router,
  store,
  vuetify,
  render: (h) => h(App),
}).$mount("#app");
